<template>
  <div id="aboutus">
  	<mt-header title="关于我们"  fixed>
		  <a href="javascript:void(0)" slot="left" @click="returnBack">
		    <mt-button icon="back" class="font-Yahei"></mt-button>
		  </a>
	</mt-header>
	<div class="mt40"> 
		<p class="text-center pt60"><img src="../../../static/images/logo.png" alt="LOGO" width="90"/></p>
	</div>
	<div class="about-box">
		<p class="mt30 display-inline">客服热线：0755-82126233</p>
		<p>客服&nbsp;QQ：793870443、1795024384</p>
		<p class="mt25">工作时间：周一至周五9:00-18:00，非工作时间请在QQ留言。</p>
	</div>
  </div>
</template>

<script>
	export default{
		data(){
			return{
			   
			}
		},
		created:function(){
			
	    },
	    methods: {
	      returnBack(){
	       	 this.$router.go(-1);
	      },
	    }
	}
</script>

<style scoped="scoped">
.about-box{background: #fff;color: #333;margin: 10% auto;font-size: 0.9rem;height: 116px;line-height: 25px;width: 80%;}
</style>


// WEBPACK FOOTER //
// src/views/UserCenter/aboutUs.vue